export default function CtaBand() {
  return (
    <section className="w-full bg-accent-600 py-12 md:py-16">
      <div className="mx-auto max-w-6xl px-4 text-center md:px-6">
        <span className="inline-flex items-center gap-2 rounded-full bg-accent-500/60 px-3 py-1 text-xs font-medium text-background-50">
          <i className="ri-sun-fill text-sm" />
          明天 21:00，不见不散
        </span>
        <h2 className="mx-auto mt-5 max-w-2xl font-heading text-2xl font-black leading-snug text-background-50 md:text-4xl md:leading-tight">
          今天先在这歇脚，明天同一时间，接着吃料
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-sm leading-7 text-background-100">
          今日汇总、热门合集、精选打包都在这一页滚动收好。收藏本站，之后想吃随时回来，一处就够。
        </p>
        <div className="mt-7 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <a
            href="#packs"
            className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full bg-foreground-950 px-6 py-3 text-sm font-semibold text-background-50 transition-opacity hover:opacity-90 sm:w-auto"
          >
            一键开吃
            <i className="ri-arrow-right-line text-base" />
          </a>
          <a
            href="#top"
            className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full border border-background-50/70 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-background-50 hover:text-accent-700 sm:w-auto"
          >
            回到顶部
          </a>
        </div>
      </div>
    </section>
  );
}